<template>
  <div>
    <w-title-bar :title="title" textColor="#000000"></w-title-bar>
    <iframe v-bind:src="requestUrl" width="100%" :height="iframeHeight" frameborder="0" scrolling="auto"></iframe>
  </div>
</template>
<style>

</style>
<script>
  import wTitleBar from "@/components/w-titleBar";
  import axios from "axios";
  export default{
    name: "success",
    components: {
      wTitleBar,
    },
    data () {
      return {
        requestUrl: '',
        loading: false,
        title: '真品无双',
        iframeHeight: 500
      }
    },
    mounted () {
      // 计算iframe高度
      this.iframeHeight = document.documentElement.clientHeight - 44
      // 解绑
      if (window.initNfc != null) {
        window.initNfc = null;
      }
      if (window.doSingle != null) {
        window.doSingle = null;
      }
      let queryObj = this.$route.query.data;
      
      let checkFlag = queryObj.checkFlag;
      //checkFlag 1 启用开瓶检测 2 禁用开瓶检测
      if(checkFlag === "2"){
        this.requestUrl = queryObj.hide;
      }
      else{
        let check = queryObj.check;
        //check 105 已开封 106 未开封
        if(check === 105){
          this.requestUrl = queryObj.open;
        }
        else{
          this.requestUrl = queryObj.notOpen;
        }
      }
      console.log("参数"+this.requestUrl);
    }
  }
</script>


// WEBPACK FOOTER //
// src/pages/result/success.vue